export default __webpack_public_path__ + "static/media/ger2.0194a174.JPG";